import { render, staticRenderFns } from "./ProfessionalProfileCard.vue?vue&type=template&id=f0c38374&"
import script from "./ProfessionalProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProfessionalProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalProfileCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports